<template>
   <v-row dense>
      <v-col cols="12" sm="12">
        <v-card
          class="pa-0 pt-6 rounded-0 elevation-0"
          :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
        >
          <v-sheet
            class="transactionTable ib-commission-table"
            :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'"
          >
            <v-data-table
              :headers="headers"
              :items-per-page="5"
              :items="clientInfo"
            >
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { TRADEMASTER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Acc. No", align: "start", value: "account_no" },
        { text: "Full Name", value: "client_name" },
        { text: "Acc. Type", value: "account_type" },
        { text: "Balance", value: "balance" },
        { text: "Equity", value: "equity" },
        { text: "Commission", value: "commission" },
        { text: "Level", value: "level" },
      ],
    };
  },
  computed: {
    ...mapState("tradeMaster", ["levelClients"]),

    clientInfo() {
      return this.levelClients.clients
    }
  },

  methods: {
    ...mapActions("tradeMaster", [TRADEMASTER__ACTIONS.LEVELCLIENTS]),

    getColor(status) {
      if (status == "Approved")
        return "color: #039de9; background-color: rgba(2, 181, 138, 0.15); padding: 8px 13px; border-radius: 2px;";
      else if (status == "Decline") return "color: red";
      else return "color: yellow";
    },
  },

  async mounted() {
    await this[TRADEMASTER__ACTIONS.LEVELCLIENTS](this.$route.params.id);
  },
};
</script>
